import dayjs from 'dayjs';
export const appName = "NPHCDA";
export const expiryTime = 2;
export const clientDetail = "NPHCDA_user";
export const clientToken = `${appName}_user_token`;
export const clientTheme = `${appName}_user_theme`;
export const clientRightNavIsOpen = `${appName}_right_nav_is_open`;
export const clientLeftNavIsOpen = `${appName}_left_nav_is_open`;
export const clientVisualizationType = `${appName}_visualization_type`;
export const clientPHCView = `${appName}_phc_view`;
export const appDashboardData = `${appName}_dashboard_data`;
export const appDashboardDataSetDate = `${appName}_dashboard_data_set_date`;

export const locationBoundaryDS = `${appName}_location_boundary_data`;
export const boundaryDS = `${appName}_boundary_data`;
export const dashboardDS = `${appName}_dashboard_data`;
export const maxValueDS = `${appName}_maxValue_data`;
export const lastUpdated = `${appName}_last_updated`;

export const staleTime = 1000 * 60 * 60 * 24 * 30;
export const staleTimeExpiry = dayjs().add(30, "day").valueOf();

const size = 8;

export const dateFormats = {
  DATE: "MM/DD/YYYY",
  DATE_ALT: "DD MMM, YYYY",
  DATE_TIME: "MM-DD-YYYY hh:mm A",
  DATE_TIME_2: "MMM-DD-YYYY hh:mm A",
  TIME: "hh:mm A",
  YEAR: "YYYY",
  YYYYMMDD: "YYYY-MM-DD",
  HHMMSS: "HH:mm:ss",
  DDMMM: "DD MMMM",
  FULLTIME: "YYYY-MM-DDTHH:mm:ssZ",
  FULLTIME_2: "YYYY-MM-DDTHH:mm:ss.SSSZ",
};

export const MAX_COUNT = 10;

export const chartColors = ["#095e29", "#0472EE", "pink", "#19BD56", "#F7D034"];

export const PHC = "e70967b3-10d8-416e-9c21-7f7278375ce9";
export const mMortality = "fcd92102-42b9-4f9b-bcfe-295ad505a1a5";
export const countryId = "09a25923-91c2-4412-87a1-310edfd878b9";

export const Tokens = {
  colors: {
    secondary: "#E2341D",
    surface: "#B4D4ED",
    // surface: "#F5f5f5",
    error: "#E2341D",
    white: "#FFFFFF",
    dark: "#101928",
    border: "#D0D5DD",
    borderSurface: "#E9F0F4",
    borderDark: "#798AA3",

    transparentDark: "rgba(0,0,0,0.2)",
    transparentLight: "rgba(255,255,255,0.2)",
    text: {
      primary: "#101928",
      light: "#344054",
      lighter: "#A5ACBA",
      white: "#ffffff",
    },
  },
  dimension: {
    x: size,
    x2: size * 2,
    x3: size * 3,
    x4: size * 4,
    x5: size * 5,
    x6: size * 6,
    x7: size * 7,
    x8: size * 8,
    x10: size * 10,
    x12: size * 12,
    x16: size * 16,
    x24: size * 24,
    x32: size * 32,

    spacing: {
      mico: size / 2,
      small: size,
      medium: size * 2,
      large: size * 3,
      xlarge: size * 4,
    },
    radius: {
      medium: size / 2,
      large: size,
      xlarge: size * 2,
    },
  },
} as const;

export const ATTRIBUTIONS: string[] = [
  '<a href="https://www.maptiler.com/copyright/" target="_blank">&copy; MapTiler</a>',
  '<a href="https://www.openstreetmap.org/copyright" target="_blank">&copy; OpenStreetMap contributors</a>',
];

export const queryFields = [
  "_submission_time",
  "group1/group_2/zone",
  "group1/group_2/state",
  "group1/group_2/lga",
  "group1/group_2/ward",
  "group1/group_2/hf_name",
  "_id",
  "group1/group_fds/dc_name",
  "group1/group_fds/dc_phone",
  "group1/group_2/hf_assessdbf",
  "group1/group_2/type_impart",
  "group1/group_2/referral",
  "group1/group_2/state_referral",
  "group1/group_3/med_doc",
  "group1/group_3/nurse",
  "group1/group_3/schew",
  "group1/group_3/jchew",
  "group1/group_5/delivery_room",
  "group1/group_8/spf",
  "group1/group_5/power",
  "group1/group_5/backup_power",
  "group1/group_9/in_p_bed",
  "group1/group_5/inpatient_ward",
  "group1/group_10/cce_num",
  "group1/group_8/sp_malaria",
  "group1/group_2/oic_name",
  "group1/group_2/oic_phnum",
  "remk",
  "group1/group_2/hf_inused",
  "group1/group_2/alt_hf",
];
